module.exports = __webpack_public_path__ + "img/yale2018.8fd15f93.png";